var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "44",
        "height": "44",
        "viewBox": "0 0 88 88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "-29.875%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColotBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "fill": "url(#a)",
        "cx": "44",
        "cy": "44",
        "r": "44"
      }
    }), _c('path', {
      attrs: {
        "d": "M28 28h32v32H28z"
      }
    }), _c('g', {
      attrs: {
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M43.813 59.594c-8.717 0-15.782-7.065-15.782-15.781 0-8.717 7.065-15.782 15.782-15.782 8.716 0 15.781 7.065 15.781 15.782 0 8.716-7.065 15.781-15.781 15.781z",
        "fill": "#FFF"
      }
    }), _c('path', {
      attrs: {
        "d": "M50.31 37.774V50.31a.928.928 0 01-.927.928h-11.14a.928.928 0 01-.929-.928V37.314a.928.928 0 01.93-.928h10.683c.77 0 1.384.622 1.384 1.388z",
        "fill": "var(--homeIconCenterColor)"
      }
    }), _c('path', {
      attrs: {
        "d": "M43.84 40.126a3.717 3.717 0 00-3.714 3.714 3.717 3.717 0 003.714 3.713 3.717 3.717 0 003.713-3.713 3.717 3.717 0 00-3.713-3.714zm-2.732 3.714a2.735 2.735 0 012.732-2.732c.591 0 1.139.189 1.587.51l-3.809 3.808a2.716 2.716 0 01-.51-1.586zm2.732 2.732c-.54 0-1.069-.16-1.517-.462l3.787-3.787c.291.434.462.956.462 1.517a2.735 2.735 0 01-2.732 2.732z",
        "fill": "#FFF"
      }
    })])])]));
  }
};